/**
 * FEAT-107 / S-344 — why a social post failed, in words the person can act on.
 *
 * `social_calendar.dispatch_error` holds whatever the provider said. The ones
 * seen in production (2026-10-14) get a sentence that says what to do; any
 * other message is shown as the provider wrote it, never hidden.
 */
const KNOWN: Array<{ match: RegExp; message: string }> = [
  {
    match: /already got this one scheduled or posted/i,
    message: "Buffer refused a duplicate: the same text was already scheduled or posted around then. Change the text or the time, then Retry.",
  },
  {
    match: /accounts do not belong to this user/i,
    message: "This account is no longer connected to your Zernio profile. Reconnect it in Settings → Social accounts, then Retry.",
  },
];

export function describeDispatchError(raw: string | null | undefined): string | null {
  const text = (raw ?? "").trim();
  if (!text) return null;
  return KNOWN.find((k) => k.match.test(text))?.message ?? text;
}
